import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Form, Select, Row, Col, Button, notification
} from 'antd';
import moment from 'moment';

import { useTranslation } from 'react-i18next';
import ItemInterpretation from '../../../../containers/item-interpretation';

import { actions, selectors } from '../../../../models';
import { getCurrentCalculatorMordovia, isCalcGroupErroneous } from '../../../../models/mordovia/selectors';

const { addGroupCalculate } = actions;
const { curInterpretation, curPoints } = selectors;

const methods = ['field', 'points', 'zones'];

const Interpretation = ({ isCompleted, year, isLaborant }) => {
    const isGroupError = useSelector(state => isCalcGroupErroneous(state));
    const calculator = useSelector(state => getCurrentCalculatorMordovia(state));
    const interpretation = useSelector(state => curInterpretation(state));
    const fieldCalc = useSelector(state => getCurrentCalculatorMordovia(state));
    const points = useSelector(state => curPoints(state));
    const dispatch = useDispatch();
    const [type, setType] = useState(interpretation.type || 'field');
    const [filteredPoints, setFilteredPoints] = useState([]);
    const [filteredZones, setFilteredZones] = useState({});
    const [notFull, setNotFull] = useState(true);
    const [form] = Form.useForm();

    const { t } = useTranslation('interpretation');

    useEffect(() => {
        if (!calculator?.planned_yield > 0 && isGroupError?.error?.length > 0) {
            notification.error({
                message: 'Ошибка',
                description: 'Задайте планируемую урожайность поля для проведения расчета'
            });
        }
    }, [isGroupError]);
    

    useEffect(() => {
        form.setFieldsValue({
            year: interpretation.year || year,
            points: interpretation.points,
            zones: interpretation.zones,
            type: interpretation.type || 'field'
        });
        points?.forEach((item) => {
            if (item => item.date.split('-')[0] === interpretation.year) {
                filteredPoints.push(item);
                filteredZones[item.productivity_zone] = item.productivity_zone;
            }
        });
        setFilteredPoints([...filteredPoints]);
        setFilteredZones({ ...filteredZones });
    }, []);

    const onValuesChange = (value, values) => {
        let tempNotFull = false;
        if (value.year) {
            const filteredPoints = [];
            const filteredZones = {};
            points?.forEach((item) => {
                if (item => item.date.split('-')[0] === value.year) {
                    filteredPoints.push(item);
                    filteredZones[item.productivity_zone] = item.productivity_zone;
                }
            });
            setFilteredPoints([...filteredPoints]);
            setFilteredZones({ ...filteredZones });
        }
        if (value.type === 'zones' || value.type === 'points') {
            setNotFull(true);
            form.setFieldsValue({ zones: undefined, points: undefined });
            return;
        }
        if (values.type === 'field' && year) {
            setNotFull(!values.method);
            return;
        }
        Object.values(values).forEach(item => { if (!item) tempNotFull = true; });
        if (tempNotFull !== notFull) {
            setNotFull(tempNotFull);
        }
    };

    const onFinish = (values) => {
        values.year = year;
        dispatch(addGroupCalculate({ vega_key: calculator.vega_key, body: values }));
    };

    const changeMethod = (type) => {
        setType(type);
    };

    const [pointDateOptions, setPointDateOptions] = useState([]);

    useEffect(() => {
        if (points?.length > 0) {
            const optionsArray = [];
            points?.forEach((item) => {
                if (!optionsArray.includes(item.date)) {
                    optionsArray.push(item.date);
                }
            });
            const reformatOptions = optionsArray?.map(x => {
                return {
                    label: moment(x)?.format('DD.MM.YYYY'),
                    value: x
                };
            });
            setPointDateOptions(reformatOptions);
        }
    }, [points]);
    
    const methodOptions = [
        {
            label: t('kirsanov'),
            value: 'kirsanov'
        },
        {
            label: t('chirikov'),
            value: 'chirikov'
        },
        {
            label: t('machigin'),
            value: 'machigin'
        }
    ];

    // useEffect(() => {
    //     if (interpretation?.error === 'Planned yield is required') {
    //         notification.error({
    //             message: 'Ошибка',
    //             description: 'Задайте планируемую урожайность поля для проведения расчета'
    //         });
    //     }
    // }, [interpretation]);
    
    return (
        <div>
            {points && !isLaborant && (
                <Form onValuesChange={onValuesChange} form={form} onFinish={onFinish} style={{ marginBottom: '30px' }}>
                    <Row gutter={20}>
                        <Col span={6}>
                            <Form.Item name="analysis_date">
                                <Select placeholder={t('analysis_date placeholder')} options={pointDateOptions} />
                                {/* <Select placeholder={t('analysis_date placeholder')}>
                                    {points.map(point => (
                                        <Select.Option key={point?.date} value={point?.date}>
                                            {moment(point?.date)?.format('DD.MM.YYYY')}
                                        </Select.Option>
                                    ))}
                                </Select> */}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item name="method"
                                rules={[{ required: true, message: t('method placeholder') }]}>
                                <Select placeholder={t('method placeholder')} options={methodOptions} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item name="type">
                                <Select onChange={changeMethod} disabled={!points?.length}>
                                    {methods.map(item => (
                                        <Select.Option key={item} value={item}>
                                            {t(item)}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            {(type === 'points') && (
                                <Form.Item name="points">
                                    <Select mode="multiple">
                                        {filteredPoints.map(item => (
                                            <Select.Option key={item.id} value={item.point_number}>
                                                {item.point_number}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            )}
                            {(type === 'zones') && (
                                <Form.Item name="zones">
                                    <Select mode="multiple">
                                        {Object.keys(filteredZones).map(item => (
                                            <Select.Option key={item} value={item}>
                                                {t(item)}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button disabled={notFull}
                                htmlType="submit"
                                type="primary"
                                size="large">
                                {t('calculate')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            )}
            {(!points || type) && (
                <ItemInterpretation isLaborant={isLaborant} isCompleted={isCompleted} />
            )}
        </div>
    );
};

export default Interpretation;